module.exports = __webpack_public_path__ + "assets/7c5f33c526e6b974fb927b2acf7b92d6.png";